import { useState } from 'react'
import { postClarificationStream } from '@/services/chatStream/postClarificationStream'
import { clarificationAnswerText } from './clarificationAnswerText'
import { publishClarificationSubmitted } from './clarificationChannel'

/**
 * Drive one clarification card.
 *
 * `submitted` is local optimistic state, not the card's authority — the durable
 * record is the message metadata, which a reload re-reads. A `409` means another
 * tab won; the card flips to submitted and the thread refetch that follows
 * replaces it with the real one, which beats leaving an answered form open.
 */
export function useClarificationSubmit(block) {
  const [submitted, setSubmitted] = useState(block.status === 'submitted')
  const [pending, setPending] = useState(false)
  const [error, setError] = useState(null)

  const submit = async (answers) => {
    if (pending || submitted) return
    setPending(true)
    setError(null)
    try {
      const response = await postClarificationStream({
        assistantMessageId: block.assistant_message_id,
        answers,
      })
      setSubmitted(true)
      publishClarificationSubmitted({
        assistantMessageId: block.assistant_message_id,
        answers,
        content: clarificationAnswerText(block, answers),
        response,
      })
    } catch (caught) {
      if (caught?.status === 409) setSubmitted(true)
      else setError(caught?.message || 'Could not submit those answers')
    } finally {
      setPending(false)
    }
  }

  return { submitted, pending, error, submit }
}
